


















































































import {
    Vue, Component, Prop, Mixins,
} from 'vue-property-decorator'
import {State, Getter} from 'vuex-class'

@Component
export default class Page extends Vue {
    @Prop({default: false}) transparent!: boolean   // 背景是否透明

    @Prop({default: false}) noPadding!: boolean   // header没有边距

    @Prop({default: false}) noPaddingBody!: boolean   // body没有边距

    @Prop({default: false}) stickyHeader!: boolean   // header固定

    @State('collapseMenu') collapseMenu

    @Prop({default: true}) showShadow!: boolean

    @Prop({default: false}) isFromInsurance!: boolean

    created() {
    }
}
